import { render } from "./PhoneShareTab.vue?vue&type=template&id=788517c5&scoped=true"
import script from "./PhoneShareTab.vue?vue&type=script&lang=js"
export * from "./PhoneShareTab.vue?vue&type=script&lang=js"

import "./PhoneShareTab.vue?vue&type=style&index=0&id=788517c5&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788517c5"]])

export default __exports__